// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanel from 'viewmodel/AwPanelViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwTextbox from 'viewmodel/AwTextboxViewModel';
import AwCommandPanelSection from 'viewmodel/AwCommandPanelSectionViewModel';
import AwList from 'viewmodel/AwListViewModel';
import AwDefaultCell from 'viewmodel/AwDefaultCellViewModel';
import AwPanelFooter from 'viewmodel/AwPanelFooterViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';
import AwI18n from 'viewmodel/AwI18nViewModel';
    import { EnableWhen } from 'js/hocCollection';
const AwButtonEnableWhen = EnableWhen(AwButton);
AwButtonEnableWhen.displayName = 'AwButtonEnableWhen';

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/DesTeamMembersService', () => import('js/DesTeamMembersService'));
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/desCatalogEventBus', () => import('js/desCatalogEventBus'));
registerDynImportEntry('js/DesTeamService', () => import('js/DesTeamService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "data": {
        "teamName": {
            "displayName": "Team Name",
            "type": "STRING",
            "isRequired": "true",
            "isEditable": "true",
            "dbValue": "",
            "dispValue": "",
            "requiredText": "{{i18n.requiredNoSpaceString}}"
        },
        "description": {
            "displayName": "Description",
            "type": "STRING",
            "isRequired": "true",
            "isEditable": "true",
            "dbValue": "",
            "dispValue": "",
            "requiredText": "{{i18n.requiredString}}"
        },
        "commands": "aw_addTeamMemberCommandAnchor",
        "filteredObj": [],
        "filteredMembers": [],
        "membersListOnMainPanel": []
    },
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "teamid": {
            "type": "string"
        },
        "collaborationspaceid": {
            "type": "string"
        },
        "sub-panel-context": {
            "type": "object"
        }
    },
    "actions": {
        "initializeDataProvider": {
            "actionType": "dataProvider",
            "method": "assignedTeamMembersProvider"
        },
        "reveal": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "getTeamDetails"
                },
                {
                    "action": "getTeamMembers"
                },
                {
                    "action": "initializeDataProvider"
                }
            ]
        },
        "editTeamAction": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "getTeamMembers"
                },
                {
                    "action": "editTeam"
                },
                {
                    "action": "parseMemberArrays"
                }
            ]
        },
        "performBatchActionOnNavigation": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "resetArrays"
                },
                {
                    "action": "navigateAction"
                }
            ]
        },
        "storeInitialMembers": {
            "actionType": "JSFunction",
            "method": "storeInitialMembers",
            "inputData": {
                "vmo": "{{data}}",
                "listTeamMembers": "{{data.members}}"
            },
            "deps": "js/DesTeamMembersService"
        },
        "resetArrays": {
            "actionType": "JSFunction",
            "method": "resetArrays",
            "inputData": {
                "vmo": "{{data}}"
            },
            "deps": "js/DesTeamMembersService"
        },
        "navigateAction": {
            "actionType": "JSFunction",
            "method": "switchPanel",
            "inputData": {
                "commandContext": "{{props.subPanelContext.sharedData}}",
                "panelView": "editTeamSubPanel"
            },
            "deps": "js/DesTeamMembersService"
        },
        "getTeamMembers": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationspaceid": "{{props.collaborationspaceid}}"
                        },
                        "query": "query ListTeamMembers($listTeamMembersInput: ListTeamMembersInput) {listTeamMembers(listTeamMembersInput: $listTeamMembersInput) }",
                        "variables": {
                            "listTeamMembersInput": {
                                "teamId": "{{props.teamid}}",
                                "searchOptions": {
                                    "outputProperties": [
                                        "*"
                                    ]
                                }
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}"
            },
            "outputData": {
                "members": "data.data.listTeamMembers.filterObj",
                "totalFound": "data.data.listTeamMembers.totalFound"
            },
            "events": {
                "failure": [
                    {
                        "name": "members.failure",
                        "condition": "members.hasError === true",
                        "eventData": {
                            "eventName": "desMembersFailure",
                            "eventData": "{{members}}"
                        }
                    }
                ],
                "success": [
                    {
                        "name": "members.success",
                        "condition": "members.hasError === false",
                        "eventData": {
                            "eventName": "members.success",
                            "eventData": "{{members}}"
                        }
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "getTeamDetails": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationspaceid": "{{props.collaborationspaceid}}"
                        },
                        "query": "query ListAllTeams($listTeamsInput: ListTeamsInput) {listAllTeams(listTeamsInput: $listTeamsInput)}",
                        "variables": {
                            "listTeamsInput": {
                                "filters": {
                                    "teamId": [
                                        "{{props.teamid}}"
                                    ]
                                },
                                "searchOptions": {
                                    "skip": 0,
                                    "limit": 10,
                                    "outputProperties": [
                                        "*"
                                    ]
                                }
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}"
            },
            "outputData": {
                "teamListViewTotalResults": "data.data.listAllTeams.totalCount",
                "teamListViewResponse": "data.data.listAllTeams.teamObjs"
            },
            "events": {
                "failure": [
                    {
                        "name": "listAllTeams.failure",
                        "eventData": {
                            "eventName": "listAllTeamsFailure",
                            "eventData": "{{teamListViewResponse}}"
                        }
                    }
                ],
                "success": [
                    {
                        "name": "getTeamDetails.success",
                        "eventData": {
                            "eventName": "listAllTeamsSuccess",
                            "eventData": "{{teamListViewResponse}}"
                        }
                    }
                ]
            },
            "actionMessages": {
                "failure": [
                    {
                        "message": "queryFailedMessage"
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "addMembers": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationspaceid": "{{props.collaborationspaceid}}",
                            "assignedTeamMembers": "{{parameters.eventData}}",
                            "teamId": "{{props.teamid}}"
                        },
                        "query": "mutation AddTeamMembers( $addTeamMembersInput: Json) {addTeamMembers( addTeamMembersInput: $addTeamMembersInput )}",
                        "variables": {
                            "addTeamMembersInput": {
                                "addTeamMembersInput": {}
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}"
            },
            "outputData": {
                "addedTeamMembers": "data.data.addTeamMembers"
            },
            "events": {
                "failure": [
                    {
                        "name": "addTeamMembers.failure",
                        "eventData": {
                            "eventName": "addTeamMembersFailure",
                            "eventData": "{{addedTeamMembers}}"
                        }
                    }
                ],
                "success": [
                    {
                        "name": "addTeamMembers.success",
                        "condition": "addTeamMembers.hasError === false",
                        "eventData": {
                            "eventName": "addTeamMembersSuccess",
                            "eventData": "{{addedTeamMembers}}"
                        }
                    }
                ]
            },
            "actionMessages": {
                "success": [
                    {
                        "message": "displayDesCreateTeamSuccessMsg",
                        "condition": "createdTeam.hasError === false"
                    },
                    {
                        "message": "displayDesCreateUserFailureMsg",
                        "condition": "createdTeam.hasError === true"
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "removeMembers": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationspaceid": "{{props.collaborationspaceid}}",
                            "emailsOfMembersToRemove": "{{parameters.eventData}}"
                        },
                        "query": "mutation RemoveTeamMembers( $removeTeamMembersInput: Json) {removeTeamMembers( removeTeamMembersInput: $removeTeamMembersInput )}",
                        "variables": {
                            "removeTeamMembersInput": {
                                "teamId": "{{props.teamid}}"
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}"
            },
            "outputData": {
                "removeTeamMembers": "data.data.removeTeamMembers"
            },
            "events": {
                "failure": [
                    {
                        "name": "desRemoveTeamMembersFailure",
                        "condition": "removeTeamMembers.hasError === false",
                        "eventData": {
                            "eventName": "desRemoveTeamMembersFailure",
                            "eventData": "{{removeTeamMembers}}"
                        }
                    }
                ],
                "success": [
                    {
                        "name": "desRemoveTeamMembersSuccess",
                        "condition": "removeTeamMembers.hasError === false",
                        "eventData": {
                            "eventName": "desRemoveTeamMembersSuccess",
                            "eventData": "{{removeTeamMembers}}"
                        }
                    }
                ]
            },
            "actionMessages": {
                "success": [
                    {
                        "message": "displayDesUpdateTeamSuccessMsg",
                        "condition": "removeTeamMembers.hasError === false"
                    },
                    {
                        "message": "displayDesCreateUserFailureMsg",
                        "condition": "removeTeamMembers.hasError === true"
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "editTeam": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationspaceid": "{{props.collaborationspaceid}}"
                        },
                        "query": "mutation UpdateTeam( $teamId: String, $updateTeamInput: UpdateTeamInput) {updateTeam( teamId: $teamId, updateTeamInput: $updateTeamInput )}",
                        "variables": {
                            "teamId": "{{props.teamid}}",
                            "updateTeamInput": {
                                "teamName": "{{data.teamName.dbValue}}",
                                "description": "{{data.description.dbValue}}"
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}"
            },
            "outputData": {
                "updateTeam": "data.data.updateTeam"
            },
            "events": {
                "failure": [
                    {
                        "name": "updateTeam.failure",
                        "eventData": {
                            "eventName": "desUpdateTeamFailure",
                            "eventData": "{{updateTeam}}"
                        }
                    }
                ],
                "success": [
                    {
                        "name": "desUpdateTeamSuccess",
                        "eventData": {
                            "eventData": "{{updateTeam}}"
                        }
                    }
                ]
            },
            "actionMessages": {
                "success": [
                    {
                        "message": "displayDesUpdateTeamSuccessMsg"
                    }
                ],
                "failure": [
                    {
                        "message": "displayDesCreateUserFailureMsg"
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desCatalogEventBus"
        },
        "updateloadedTeamDetails": {
            "actionType": "JSFunction",
            "method": "getSelectedTeamDetails",
            "inputData": {
                "vmo": "{{data}}",
                "eventData": "{{data.teamListViewResponse}}"
            },
            "deps": "js/DesTeamService"
        },
        "getAssignedTeamMembers": {
            "actionType": "JSFunction",
            "method": "getAssignedTeamMembers",
            "inputData": {
                "sharedData": "{{props.subPanelContext.sharedData}}",
                "listTeamMembers": "{{data.members}}",
                "membersAfterRemovalAction": "{{data.filteredObj}}",
                "filteredMembersAfterRemoval": "{{data.filteredMembers}}",
                "vmo": "{{data}}"
            },
            "outputData": {
                "memberObj": "membersListOnMainPanel",
                "totalAssignedTeamMembers": "totalAssignedTeamMembers"
            },
            "events": {
                "success": [
                    {
                        "name": "getAssignedTeamMembers.success",
                        "eventData": {
                            "eventName": "getAssignedTeamMembers.success",
                            "eventData": "{{memberObj}}"
                        }
                    }
                ]
            },
            "deps": "js/DesTeamMembersService"
        },
        "removeTeamMembers": {
            "actionType": "JSFunctionAsync",
            "method": "removeTeamMembers",
            "inputData": {
                "commandContext": "{{commandContext.vmo}}",
                "membersToRemove": "{{data.memberObj}}",
                "vmo": "{{data}}"
            },
            "outputData": {
                "filteredObjArray": "filteredObj",
                "filteredMembersArray": "filteredMembers"
            },
            "events": {
                "failure": [
                    {
                        "name": "removeTeamMembersFailure",
                        "eventData": {
                            "eventName": "removeTeamMembersFailure",
                            "eventData": "{{filteredObjArray}}"
                        }
                    }
                ],
                "success": [
                    {
                        "name": "removeTeamMembersSuccess",
                        "eventData": {
                            "eventName": "removeTeamMembersSuccess",
                            "eventData": "{{filteredObjArray}}"
                        }
                    }
                ]
            },
            "deps": "js/DesTeamMembersService"
        },
        "parseMemberArrays": {
            "actionType": "JSFunctionAsync",
            "method": "parseMemberArrays",
            "inputData": {
                "vmo": "{{data}}",
                "initialMembersFromQuery": "{{data.members}}"
            },
            "outputData": {
                "membersToAdd": "membersToAdd",
                "emailsOfMembersToRemove": "emailsOfMembersToRemove"
            },
            "events": {
                "success": [
                    {
                        "name": "membersToAddSuccess",
                        "condition": "data.membersToAdd.length>0",
                        "eventData": {
                            "eventName": "membersToAddSuccess",
                            "eventData": "{{membersToAdd}}"
                        }
                    },
                    {
                        "name": "emailsOfMembersToRemoveSuccess",
                        "condition": "data.emailsOfMembersToRemove.length>0",
                        "eventData": {
                            "eventName": "emailsOfMembersToRemoveSuccess",
                            "eventData": "{{emailsOfMembersToRemove}}"
                        }
                    }
                ]
            },
            "deps": "js/DesTeamMembersService"
        }
    },
    "dataProviders": {
        "assignedTeamMembersProvider": {
            "action": "getAssignedTeamMembers",
            "response": "{{data.memberObj}}",
            "totalFound": "{{data.totalAssignedTeamMembers}}",
            "commandsAnchor": "des_removeTeamMemberCommandAnchor"
        }
    },
    "conditions": {
        "enableEditTeamButton": {
            "expression": "data.teamName.dbValue && data.description.dbValue"
        }
    },
    "onEvent": [
        {
            "eventId": "awPanel.navigate",
            "action": "performBatchActionOnNavigation"
        },
        {
            "eventId": "storeData.success",
            "action": "initializeDataProvider"
        },
        {
            "eventId": "removeTeamMembersSuccess",
            "action": "initializeDataProvider"
        },
        {
            "eventId": "getTeamDetails.success",
            "action": "updateloadedTeamDetails",
            "inputArgs": {
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "desUpdateTeamSuccess",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventName": "desUpdateTeamSuccess",
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "removeTeamMemberAction",
            "action": "removeTeamMembers",
            "inputArgs": {
                "eventName": "removeTeamMemberAction",
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "membersToAddSuccess",
            "action": "addMembers",
            "inputArgs": {
                "eventName": "membersToAddSuccess",
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "emailsOfMembersToRemoveSuccess",
            "action": "removeMembers",
            "inputArgs": {
                "eventName": "emailsOfMembersToRemoveSuccess",
                "eventData": "{{eventData.eventData}}"
            }
        }
    ],
    "messages": {
        "displayDesUpdateTeamSuccessMsg": {
            "messageType": "INFO",
            "messageText": "\"{0}\" updated successfully",
            "messageTextParams": [
                "{{data.teamName.dbValue}}"
            ]
        },
        "displayDesUpdateTeamFailureMsg": {
            "messageType": "ERROR",
            "messageText": "{{i18n.updateTeamFailedMsg}}"
        }
    },
    "i18n": {
        "commandPanelDemo": [
            "DesTeamMessages"
        ],
        "teamName": [
            "DesTeamMessages"
        ],
        "description": [
            "DesTeamMessages"
        ],
        "message": [
            "DesTeamMessages"
        ],
        "saveButton": [
            "DesTeamMessages"
        ],
        "submitButtonTitle": [
            "TCUICommandPanelsMessages"
        ],
        "updateTeamSuccessMsg": [
            "DesTeamMessages"
        ],
        "teamMembers": [
            "DesTeamMessages"
        ],
        "requiredNoSpaceString": [
            "DesTeamMessages"
        ],
        "requiredString": [
            "DesTeamMessages"
        ]
    },
    "_viewModelId": "DesEditTeamMainPanel",
    "_uniqueViewModelId": "DesEditTeamMainPanel",
    "ctx": {}
};

    /*
    <aw-panel>
    <aw-panel-body>
        <aw-textbox prop="data.teamName"></aw-textbox>
        <aw-textbox prop="data.description"></aw-textbox>
        <aw-command-panel-section caption="i18n.teamMembers" anchor="data.commands">
            <aw-list dataprovider="data.dataProviders.assignedTeamMembersProvider">
                <aw-default-cell vmo="item"> </aw-default-cell>
            </aw-list>
        </aw-command-panel-section>
    </aw-panel-body>
    <aw-panel-footer>
        <aw-button size='stretched' action="editTeamAction" enable-when="conditions.enableEditTeamButton">
            <aw-i18n>{{i18n.saveButton}}</aw-i18n>
        </aw-button>
    </aw-panel-footer>
</aw-panel>
    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwPanel  revealAction={actions.reveal}>
        <AwPanelBody>
            <AwTextbox {...getField("data.teamName", fields, $index, null, null )}>
            </AwTextbox>
            <AwTextbox {...getField("data.description", fields, $index, null, null )}>
            </AwTextbox>
            <AwCommandPanelSection caption={i18n.teamMembers} anchor={AwParseService.instance( "data.commands" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                <AwList dataprovider={dataProviders.assignedTeamMembersProvider} showDropArea={null} dndHandler={props.viewModel.dndHandler}>{({item, index})=>{ return <>                    <AwDefaultCell vmo={AwParseService.instance( "item" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports, item, index } )}>
                    </AwDefaultCell></> } }
                </AwList>
            </AwCommandPanelSection>
        </AwPanelBody>
        <AwPanelFooter>
            <AwButtonEnableWhen size="stretched" action={actions.editTeamAction} enableWhen={AwParseService.instance( "conditions.enableEditTeamButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                <AwI18n>
                    {AwParseService.instance( "i18n.saveButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
                </AwI18n>
            </AwButtonEnableWhen>
        </AwPanelFooter>
    </AwPanel>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;